
import { useCallback } from "react";
import * as React from "react";

export const useSearchHighlight = () => {
  const highlightText = useCallback((text: string, highlight: string) => {
    if (!highlight.trim()) return text;
    
    const regex = new RegExp(`(${highlight})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <span key={index} className="bg-yellow-200 dark:bg-yellow-800 text-black dark:text-white">
          {part}
        </span>
      ) : (
        part
      )
    );
  }, []);

  return { highlightText };
};
